var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.705 4.013c-1.566-.108-2.954.486-3.96 1.433-1.983 1.864-2.594 5.233-.136 7.56l.022.021 7.95 6.818c.117.1.268.155.425.155a.65.65 0 0 0 .424-.155l7.95-6.818.023-.02c2.445-2.315 1.83-5.684-.146-7.55-1.004-.948-2.388-1.546-3.953-1.441-1.407.095-2.882.752-4.299 2.1 0 0-1.583-1.917-4.3-2.103",
    clipRule: "evenodd"
  })));
};
export default SvgHeartFilled;